export const Spinner = ({
  className,
  dataTestId = "spinner",
}: {
  className?: string;
  dataTestId?: string;
}) => {
  return (
    <div
      className={`spinner-loader z-20 h-10 w-10 rounded-full border-[0.35rem] border-solid ${className}`}
      data-testid={dataTestId}
    />
  );
};
